import React, {Component} from 'react';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {Input} from 'reactstrap';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import api from '../../../../../api.js';
import conf from '../../../../conf.js';

class FilterLanguages extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.array,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    placeholder: 'Choisissez une langue',
  };

  constructor(props) {
    super(props);
    this.typeaheadRef = React.createRef();

    const initialValues = (props?.value[0] ?? '').split(':');
    this.state = {
      languageId: initialValues[0] !== '' ? initialValues[0] : null,
      languageLevel: initialValues.length > 1 ? initialValues[1] : conf.languageLevels.beginner.value
    };
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const prevUniverseId = prevProps?.currentUniverse.id ?? null;
    const currentUniverseId = this.props?.currentUniverse.id ?? null;
    if (currentUniverseId !== prevUniverseId) {
      this.clearTypeahead();
      this.setState({
        languageId: null,
        languageLevel: 0,
      })
    }

    if (JSON.stringify(this.props.value) !== JSON.stringify(prevProps.value)) {
      const initialValues = (this.props?.value[0] ?? '').split(':');
      if (initialValues[0] === '') {
        this.clearTypeahead();
      }
      this.setState({
        languageId: (initialValues[0] !== '') ? initialValues[0] : null,
        languageLevel: initialValues.length > 1 ? initialValues[1] : conf.languageLevels.beginner.value
      });
    }
  }

  clearTypeahead = () => {
    if (this.typeaheadRef.current) {
      this.typeaheadRef.current.clear();
    }
  };

  onLevelChange = (event) => {
    const languageLevel = parseInt(event.target.value, 10);
    this.setState({languageLevel: languageLevel});

    if (this.state.languageId && languageLevel) {
      this.props.onChange({
        languages: [this.state.languageId + ':' + languageLevel]
      });
    } else {
      this.props.onChange({languages: []});
    }
  }

  onLanguageChange = (value) => {
    const languageId = value?.[0].id ?? null;
    this.setState({languageId: languageId});

    if (languageId && this.state.languageLevel) {
      this.props.onChange({
        languages: [languageId + ':' + this.state.languageLevel]
      });
    } else {
      this.props.onChange({languages: []});
    }
  };

  onSearch = async (term) => {
    const data = (await api.languages.suggest({search: term})).data;
    this.setState({options: data});
  };

  normalizeValue = (value) => {
    if (!Array.isArray(value)) {
      value = [value];
    }

    return value;
  };

  render() {
    return (
      <div className="filter-languages row">
        <div className="col-12 mb-1">
          <AsyncTypeahead
            ref={this.typeaheadRef}
            id={`languages-typeahead`}
            className="w-100"
            clearButton={true}
            labelKey="name"
            onChange={this.onLanguageChange}
            onSearch={this.onSearch}
            onKeyDown={this.onKeyDown}
            onInputChange={this.onInputChange}
            options={this.state.options}
            isLoading={!!this.state.loading}
            selectHintOnEnter={true}
            placeholder={this.props.placeholder}
          />
        </div>
        <div className="col-12">
          <Input type="select" value={this.state.languageLevel} onChange={(e) => this.onLevelChange(e)}>
            {Object.values(conf.languageLevels).map((level) => (
              <option value={level.value} key={level.value}>{level.label}</option>
            ))}
          </Input>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    currentUniverse: state.universe.currentUniverse
  })
)(FilterLanguages);